<div class="container">
    <header class="row">
        <div class="col-12">
            <h1 class="font-weight-bold text-center accent-font-color-mid">{{ 'home.thw.welcome' | translate | uppercase }}</h1>
        </div>
    </header>
</div>
